/** @hidden */
export var TABLE_ROW_INDEX_ATTRIBUTE = 'data-grid-row-index';
/** @hidden */
export var TABLE_COL_INDEX_ATTRIBUTE = 'data-grid-col-index';
/** @hidden */
export var TABLE_PREVENT_SELECTION_ELEMENT = 'data-prevent-selection';
//# sourceMappingURL=constants.js.map